import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormUploadOtherDocs_v from "../Libs/useVesselOwnerOtherDoc";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import { ReactComponent as AddIcon } from "../../Asset/add-circle.svg";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import Spinner from "../../Utils/spinner/loading";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { toast, ToastContainer } from "react-toastify";

const VesselOwnerOtherDocs = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useFormUploadOtherDocs_v();
  const [formData, setFormData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isoverlay, setOverlay] = useState(false);
  const [signedVesselNominationAgreement, setSignedVesselNominationAgreement] =
    useState(false);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      name: newFormData[index] ? newFormData[index].name : "",
      file: file,
    };
    setFormData(newFormData);
  };

  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index] ? newFormData[index].file : null,
    };
    setFormData(newFormData);
  };

  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

  const removeDocument = (index) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  const handleFinish = (e) => {
    e.preventDefault();

    if (!signedVesselNominationAgreement) {
      toast.info(
        "You must accept the Vessel Nomination Agreement before proceeding.",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      return;
    }

    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  const capitalizeInitial = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsChecked(isChecked);
    setSignedVesselNominationAgreement(isChecked);
  };

  const handleOpenOverlay = () => {
    if (formData.length === 0) {
      toast.warn("Please upload other documents");
    } else {
      setOverlay(true);
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      {isoverlay && (
        <div className="agrement-container-agree">
          <div className="header">
            <button onClick={() => setOverlay(false)}>Back</button>
            <BlackVatugIcon onClick={() => navigate("/")} />
            <button
              className="finished"
              onClick={handleFinish}
              disabled={loading}
            >
              {loading ? <Spinner /> : "Finish"}
            </button>
          </div>
          <div className="content">
            <h1 className="title">Vessel Nomination Document</h1>

            <p className="intro">
              THIS VESSEL NOMINATION AGREEMENT is made this [0] [0], [0]
              between:
            </p>

            <ol className="list">
              <li>
                VATUG TECHNOLOGIES LIMITED. of [0] (hereinafter described as
                "Vatug Tech" which expression shall, where the context so
                admits, include its successors-in-title and assigns),
              </li>
              <p>AND</p>
              <li>
                YOU, (hereinafter described as "the Vessel Owner" which
                expression shall, where the context so admits, include your
                successors-in-title and assigns).
              </li>
            </ol>

            <h2 className="subheading">WHEREAS</h2>
            <ul className="unordered-list">
              <li>
                The Vessel Owner nominates its vessel for charter and/or sale.
              </li>
              <li>
                The Vessel Owner nominates Vatug Tech as its broker to charter
                and/or sell the vessel ("The Service").
              </li>
              <li>
                You agree that upon executing this Agreement, you subscribe to
                The Services and you agree to be bound by the terms of this
                Agreement.
              </li>
              <li>
                It is agreed that the terms of this Vessel Nomination Agreement
                shall form part of the Charter Brokerage Services Agreement.
              </li>
            </ul>

            <h2 className="subheading">STANDARD TERMS AND CONDITIONS</h2>
            <ol className="list">
              <li>
                Upon executing this Agreement, you authorize Vatug Tech to
                retain your data and contact you to discuss the terms of this
                Agreement. By signing this Agreement, you expressly consent to
                such retention and communication.
              </li>
              <li>
                You agree to execute all necessary agreements and documents
                required to give full effect to this Agreement.
              </li>
              <li>
                You agree to provide us with all documents and information
                necessary to complete our Know Your Customer (KYC) procedure.
              </li>
              <li>
                You consent to Vatug Tech being authorized to inspect the Vessel
                to confirm its condition and fitness for the intended purpose.
              </li>
              <li>
                Nothing in this Agreement shall be construed as creating a
                partnership, agency, or employment relationship between us and
                you, and neither shall have the right, power, or authority to
                create any obligation or duty, express or implied, on behalf of
                the other Party.
              </li>
              <li>
                If any provision of this Agreement is deemed void, invalid, or
                unenforceable, that provision shall be severed from the
                remainder of the Agreement. All remaining provisions of this
                Agreement shall then continue in full force.
              </li>
              <li>
                This Agreement shall be governed by, and construed in accordance
                with, the laws of the Federal Republic of Nigeria.
              </li>
              <li>
                If any dispute arises from or in connection with this Agreement,
                you agree to resolve it amicably within 21 calendar days. If we
                cannot resolve the conflict within this period, the dispute
                shall be referred to arbitration in accordance with the
                Arbitration and Mediation Act 2023.
              </li>
            </ol>

            <div className="checkbox-container">
              <input
                type="checkbox"
                id="accept"
                className="checkbox"
                required
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="accept" className="checkbox-label">
                I have read and accepted the vessel nomination agreement
              </label>
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {success && <p style={{ color: "green" }}>{success}</p>}
            <button
              className="finished"
              onClick={handleFinish}
              disabled={loading}
            >
              {loading ? <Spinner /> : "Finish"}
            </button>
          </div>
        </div>
      )}

      <div className="update-other-docs">
        <div className="wrap">
          <div className="header">
            <button onClick={() => navigate("/updates")}>Back</button>
            <BlackVatugIcon onClick={() => navigate("/")} />
            <button className="finished" onClick={handleOpenOverlay}>
              Finish
            </button>
          </div>
          <form>
            <h2>Other Documents</h2>
            {formData.map((item, index) => (
              <div key={index} className="card">
                <input
                  type="text"
                  placeholder="Input name of document"
                  value={item.name}
                  onChange={(e) => handleNameChange(e, index)}
                />
                {!item.file && (
                  <label>
                    Document
                    <span>
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleFileChange(e, index)}
                        accept=".pdf"
                      />
                      {!item.file && (
                        <>
                          <UploadIcon />
                          <p>
                            Drop pdf here, <span>or browse</span>
                          </p>
                          <h5>Supports: PDF</h5>
                        </>
                      )}
                    </span>
                  </label>
                )}
                {item.file && (
                  <div className="uploaded">
                    <div className="wrap">
                      <CiFileOn className="file" />
                      <div className="in">
                        <span>
                          <h3>{capitalizeInitial(item.name)}</h3>
                          <p>{item.file.name}</p>
                        </span>
                        <p>{formatFileSize(item.file.size)} - 100% Uploaded</p>
                      </div>
                    </div>
                    <div className="last">
                      <IoCheckmarkDoneCircleOutline className="mark" />
                      <RiDeleteBin5Line
                        onClick={() => removeDocument(index)}
                        className="delete"
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
            {formData.length <= 0 ? (
              <button type="button" onClick={addDocumentField}>
                <AddIcon />
                Add Document
              </button>
            ) : (
              <button type="button" onClick={addDocumentField}>
                <AddIcon />
                Add More Document
              </button>
            )}
            

          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default VesselOwnerOtherDocs;
